import { useCallback } from 'react'
import { type } from 'skin/event'

export default function useNav() {
	const reset = useCallback(ev => type('reset'), []);
	const signup = useCallback(ev => type('signup'), []);
	const login = useCallback(ev => type('login'), []);
	const partner = useCallback(ev => type('partner'), []);
	return { reset, signup, login, partner };
}